module.exports = __webpack_public_path__ + "img/paiqiu.e6fcd1c8.png";